$(document).ready(function () {
  // Accordion functionality
  $(document).on("click", ".accord_title", function () {
    const $parent = $(this).parent();
    if ($parent.hasClass("shrink")) {
      $(".accord_wrap .accord_item").addClass("shrink");
      $(".accord_wrap .accord_item .accord_desc").slideUp();
      $parent.removeClass("shrink").find(".accord_desc").slideDown();
    }
  });

  // Mobile menu toggle
  $(document).on("click", ".mobile-menu-cta", function () {
    $(this).toggleClass("active");
    $(".header_menu").slideToggle();
    $(".filter_input").removeClass("active");
    $(".filter_options").fadeOut();
    return false;
  });

  // Filter dropdown toggle
  $(document).on("click", ".filter_title", function () {
    const $parent = $(this).parent();
    $(".filter_input").not($parent).removeClass("active");
    $(".filter_options").not($parent.find(".filter_options")).fadeOut();
    $parent.toggleClass("active").find(".filter_options").fadeToggle();
  });

  // Close filter dropdown when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".filter_input").length) {
      $(".filter_input").removeClass("active");
      $(".filter_options").fadeOut();
    }
  });

  // Clear filter options
  $(document).on("click", ".filter_options_clear", function () {
    const $parent = $(this).parents(".filter_input");
    $parent.find(".filter_check input").prop("checked", false);
    $parent.find(".filter_counter").text(0);
    $(".filter_input").removeClass("active");
    $(".filter_options").fadeOut();
    return false;
  });

  // Update filter counter on checkbox change
  $(".filter_check input:checkbox").on("change", function () {
    const $parent = $(this).closest(".filter_input");
    const $counter = $parent.find(".filter_counter");
    let count = parseInt($counter.text(), 10) || 0;

    count += $(this).prop("checked") ? 1 : -1;
    $counter.text(count);
    return false;
  });

  // Clear all filters
  $(document).on("click", ".clearAllFilter", function () {
    $(".filter_check input").prop("checked", false);
    $(".filter_counter").text(0);
    $(".filter_input").removeClass("active");
    $(".filter_options").fadeOut();
    return false;
  });
});
